'use client';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/hooks/use-toast';
import { translateApiError } from '@/lib/i18n/translate-api-error';

export function useAppToast() {
  const { toast } = useToast();
  const { t: tc } = useTranslation('common');

  const showSuccess = useCallback(
    (title: string, description?: string) => {
      toast({
        variant: 'success',
        title,
        ...(description ? { description } : {}),
      });
    },
    [toast]
  );

  const showError = useCallback(
    (title: string, description?: string) => {
      toast({
        variant: 'destructive',
        title,
        ...(description ? { description } : {}),
      });
    },
    [toast]
  );

  const showErrorFrom = useCallback(
    (err: unknown, title: string, fallbackDescription?: string) => {
      const description =
        err instanceof Error ? translateApiError(err) : fallbackDescription ?? title;
      toast({
        variant: 'destructive',
        title,
        description,
      });
    },
    [toast]
  );

  const showWarning = useCallback(
    (title: string, description?: string) => {
      toast({
        variant: 'warning',
        title,
        ...(description ? { description } : {}),
      });
    },
    [toast]
  );

  return { toast, showSuccess, showError, showErrorFrom, showWarning, t: tc };
}
